module.exports = __webpack_public_path__ + "img/shuziziyuan.13c29a5c.png";